import React from 'react'

const Logo = () => (
  <div>
    <title>T.R. White Photo</title>
    <svg width='130px' height='130px' viewBox='0 0 516 516' version='1.1'>
      <defs />
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g id='diaphragm' fillRule='nonzero' fill='#000000'>
          <path
            d='M289.544,1.991 L214.967,131.123 L482.499,131.123 C446.312,65.22 373.904,11.416 289.544,1.991 Z M52.053,102.727 L126.595,231.876 L260.36,0.19 C185.189,-1.428 102.395,34.375 52.053,102.727 Z M20.544,358.77 L169.662,358.788 L35.896,127.102 C-3.088,191.388 -13.483,281.002 20.544,358.77 Z M226.525,514.077 L301.102,384.945 L33.571,384.945 C69.757,450.849 142.166,504.652 226.525,514.077 Z M464.017,413.342 L389.475,284.193 L255.709,515.878 C330.88,517.496 413.675,481.693 464.017,413.342 Z M495.525,157.299 L346.407,157.281 L480.173,388.967 C519.157,324.681 529.553,235.066 495.525,157.299 Z'
            id='Shape'
          />
        </g>
      </g>
    </svg>
  </div>
);

export default Logo
